import React from 'react'
import Svg, { Path } from 'react-native-svg'

export const ArrowLeft = () => {
  return (
    <Svg width={24} height={24} fill="none">
      <Path
        fill="#2C2C2C"
        fillRule="evenodd"
        d="M3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2C2C2C"
        fillRule="evenodd"
        d="M11.03 4.72a.75.75 0 0 1 0 1.06L4.81 12l6.22 6.22a.75.75 0 1 1-1.06 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 0 1 1.06 0Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
